/**
 * One constant for both the host route pattern and the `base-path` handed to the module, so the two
 * cannot drift into separate literals that happen to agree.
 */
export const PAS_BASE_PATH = '/pas';

export const PAS_ROUTE_PATTERN = `${PAS_BASE_PATH}/*`;
